import { useInputPasswordProps } from '../../hooks'
import * as Comp from './input-password-label-styles'

export const InputPasswordLabel = ({
  children,
}: { children: React.ReactNode }) => {
  const { disabled, readonly, size } = useInputPasswordProps()
  return (
    <Comp.Label
      numberOfLines={1}
      disabled={disabled}
      readonly={readonly}
      size={size}
    >
      {children}
    </Comp.Label>
  )
}
